import { createContext, useContext } from "react";

/** Whether template fields should apply their final required validation. */
export const TemplateFieldValidationContext = createContext(false);

export const useIsInFinalValidationPhase = (): boolean => {
  return useContext(TemplateFieldValidationContext);
};
